import gsap from 'gsap'

import { Animation } from '@/types'

export const footerRevealAnimation = ({
  node,
  context,
  conditions
}: Animation) => {
  if (conditions?.isSmall) return

  const selector = context?.selector || gsap.utils.selector(node)

  /**
   * references
   */
  const colophon = selector('[data-motion-colophon]')
  const scrollLine = selector('[data-motion-scroll-line]')
  const scrollLabel = selector('[data-motion-scroll-label]')

  /**
   * reveal animation
   */
  const timeline = gsap
    .timeline({ defaults: { duration: 2, ease: 'power3.inOut' } })
    .fromTo(
      [colophon],
      { yPercent: 100 },
      { yPercent: 0, stagger: { amount: 0 } }
    )
    .add(
      gsap
        .timeline({ defaults: { duration: 2, ease: 'power3.inOut' } })
        .fromTo(scrollLine, { scaleX: 0 }, { scaleX: 1 })
        .fromTo(scrollLabel, { yPercent: 100 }, { yPercent: 0 }, 0),
      0
    )

  /**
   * revert
   */
  return () => {
    timeline?.kill()
  }
}
